<template>
  <div class="background">
    <img src="../static/titlebg.jpg" class="bg" alt="">
    <div class="center">
      <!-- <div class="wlxfq-box">
        <img src="../static/wlq.png" class="wlxfq-title" alt="">
        <p class="one-p" @click="toappointment(1)"><span>婺城区文旅券</span><span>立即预约</span></p>
        <p @click="toappointment(2)"><span>开发区文旅券</span><span>立即预约</span></p>
        <p @click="toappointment(3)"><span>永康市文旅券</span><span>立即预约</span></p>
        <p @click="toappointment(4)"><span>浦江县文旅券</span><span>立即预约</span></p>
        <p @click="toappointment(8)"><span>兰溪市文旅券</span><span>立即抢券</span></p>
        <p  @click="toappointment(10)"><span>东阳市文旅券</span><span>立即预约</span></p>
        <p class="last-p" @click="toappointment(11)"><span>金义新区文旅券</span><span>立即预约</span></p>
      </div> -->
      <div class="phq-box">
        <img src="../static/phq.png" class="phq-title" alt="">
        <!-- <p class="one-p" @click="toappointment(5)"><span>婺城区消费券</span><span>立即预约</span></p>
        <p @click="toappointment(6)"><span>金义新区消费券</span><span>立即预约</span></p>
        <p @click="toappointment(7)"><span>开发区消费券</span><span>立即预约</span></p>
        <p @click="toappointment(9)"><span>武义县消费券</span><span>立即预约</span></p> -->
        <p class="last-p one-p" @click="toappointment(12)"><span>磐安县消费券</span><span>立即预约</span></p>
      </div>
    </div>



    <div class="tips" v-if="!iswx" @touchmove.prevent>
      <img src="../static/tips.png" class="tip" alt="">
    </div>
  </div>
</template>

<script>
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/_SQ_/i) == "_sq_") {
    return true;
  } else {
    return false;
  }
}
import { Dialog } from "vant";
import { Toast } from "vant";
import { isInApp, judgeWebViewIsInApp } from '../untils/jinhua-jssdk'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      iswx: true
    };
  },
  methods: {
    jump(url) {
      var a = document.createElement("a");
      a.setAttribute("target", "_blank");
      a.setAttribute("href", url);

      a.click();
    },
    toappointment(a) {
      judgeWebViewIsInApp((res) => {
        console.log(66666, res)
        if (res == 'WebViewIsInAppLoad') {


          if (a == 1) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA013018122313518032&ProvinceNo=330000&CityNo=330700&AreaNo=330702")
          } else if (a == 2) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA013018522307069091&ProvinceNo=330000&CityNo=330700&AreaNo=330792")
          } else if (a == 3) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA013109512355307258&ProvinceNo=330000&CityNo=330700&AreaNo=330784")
          } else if (a == 4) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA012815212335924315&ProvinceNo=330000&CityNo=330700&AreaNo=330726")
          } else if (a == 5) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA012110532318420859&ProvinceNo=330000&CityNo=330700&AreaNo=330702")
          } else if (a == 6) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA012110552344906853&ProvinceNo=330000&CityNo=330700&AreaNo=330703")
          } else if (a == 7) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA012110562307631801&ProvinceNo=330000&CityNo=330700&AreaNo=330792")
          } else if (a == 8) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityLoot/index?LootActivityNo=LA011013422345520019")
          } else if (a == 9) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA012110562321191751&ProvinceNo=330000&CityNo=330700&AreaNo=330723")
          } else if (a == 10) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA021013452309615115&ProvinceNo=330000&CityNo=330700&AreaNo=330783")
          }else if (a == 11) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA022815252310073972&ProvinceNo=330000&CityNo=330700&AreaNo=330703")
          }else if (a == 12) {
            this.jump("https://zljx3.yiuxiu.com/#/pagesActivityApply/index?MakeActivityNo=MA011316332310792024&ProvinceNo=330000&CityNo=330700&AreaNo=330727")
          }


        } else if (res == "noapp") {
          if (isWeiXin()) {
            this.iswx = false
          } else {
            Toast.fail('请从金彩云客户端内打开');
            this.$copyText("[jincaiyunjchjapp]https://xfqh5.jcy.jinhua.com.cn/[/jincaiyunjchjapp]").then(
              e => {
                console.log('复制成功：', e);
              },
              e => {
                console.log('复制失败：', e);
              }
            )
            location.href = 'jincaiapp://com.hoge.android.jinhua/jincaiapp';
            window.location.href = 'jincaiapp://com.hoge.android.jinhua/jincaiapp';
            setTimeout(function () {
              window.location.href = "https://appweb.jcy.jinhua.com.cn/download";
            }, 500);
            setTimeout(function () {
              location.reload();
            }, 2000);
          }
        }
      })

    },

  },
  mounted() {

  },
};
</script>

<style lang="less">
.background {
  height: 100%;
  width: 100%;
  position: relative;

  .tips {
    background-color: rgba(0, 0, 0, 0.692);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .tip {
      position: absolute;
      top: 30px;
      width: 100%;

    }
  }

  .bg {
    width: 100%;
    display: block;
    // vertical-align:top;
  }

  .center {
    position: relative;
    display: block;
    top: -1px;
    width: 100%;
    height: 400px;
    background: -webkit-linear-gradient(top, #a7e3cc, #7fd894);

    .wlxfq-box {
      position: absolute;
      top: -150px;
      padding: 0 20px;
      // width: 300px;
      margin-left: 30px;
      margin-right: 30px;
      background-color: #fff;
      border-radius: 10px;

      .wlxfq-title {
        position: absolute;
        width: 160px;
        left: 50%;
        margin-left: -80px;
        top: -10px;
      }

      p {
        width: 275px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        font-size: 20px;
        display: flex;
        background: -webkit-linear-gradient(left, #f7ab4e, #ffb921);
        margin-bottom: 15px;
        justify-content: space-around;
        text-shadow: 2px 3px 2px #ff8d00;
        border-radius: 20px;
        box-shadow: 1px 1px 4px 2px #fee6b1;
      }

      .one-p {
        margin-top: 40px;
      }

      .last-p {
        margin-bottom: 30px;
      }
    }

    .phq-box {

      position: absolute;
      top: -160px;
      padding: 0 20px;

      margin-left: 30px;
      margin-right: 30px;
      background-color: #fff;
      border-radius: 10px;

      .phq-title {
        position: absolute;
        width: 160px;
        left: 50%;
        margin-left: -80px;
        top: -10px;
      }

      p {
        width: 275px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        font-size: 20px;
        display: flex;
        background: -webkit-linear-gradient(left, #ff809d, #ff7866);
        margin-bottom: 15px;
        justify-content: space-around;
        text-shadow: 2px 3px 2px #d75248;
        border-radius: 20px;
        box-shadow: 1px 1px 4px 2px #fed9e0;
      }

      .one-p {
        margin-top: 40px;
      }

      .last-p {
        margin-bottom: 30px;
      }
    }
  }

}
</style>